<template>
    <div class="knowledge-centre-container">
      <h1 class="page-title">Knowledge Centre</h1>
      <div class="knowledge-centre-columns">
        <!-- Left column: categories & articles -->
        <div class="knowledge-centre-sidebar">
          <div v-if="loading">Loading...</div>
          <div v-else>
            <div
              v-for="(articlesInCat, catName) in categories"
              :key="catName"
              class="category-section"
            >
              <h3>{{ catName }}</h3>
              <ul>
                <li
                  v-for="article in articlesInCat"
                  :key="article.id"
                  @click="selectArticle(article)"
                  :class="['article-link', { selected: article.id === selectedArticleId }]"
                >
                  {{ article.title }}
                </li>
              </ul>
            </div>
          </div>
          <div v-if="error" class="error-message">{{ error }}</div>
        </div>
    
        <!-- Right column: selected article -->
        <div class="knowledge-centre-article">
          <div v-if="selectedArticle">
            <h2>{{ selectedArticle.title }}</h2>
            <div class="article-meta">
              <p>Last updated: {{ selectedArticle.lastUpdatedTimestamp?.toDate().toLocaleString() }}</p>
              <p>Created by: {{ selectedArticle.createdBy }}</p>
            </div>
            <!-- Render the raw EditorJS JSON as HTML -->
            <div
              class="article-content"
              v-html="parseEditorJsBlocks(selectedArticle.description)"
            ></div>
          </div>
          <div v-else>
              <div class="header-logo">
                <div id="animated-logo"></div>
              </div>
            <div class="site-title">Welcome to the Knowledge Centre</div>
            <div class="site-text">Find useful tips, how-tos and site rules. Feel free to open a Ticket in Report, if you would like us to add a new help article.</div>
          </div>
        </div>
      </div>
    </div>
  </template>  
  
  <script>
  import lottie from 'lottie-web';
  import animationData from './data.json';
  import KnowledgeCentreLogic from "./KnowledgeCentreLogic";
  
  export default {
    name: "KnowledgeCentre",
    mixins: [KnowledgeCentreLogic],
    mounted() {
      const container = this.$el.querySelector('#animated-logo');
      lottie.loadAnimation({
        container,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData
      });
    }
  };
  </script>
  
  <style scoped>
  .knowledge-centre-container {
    max-width: 1200px;
    margin: 50px auto;
    font-family: "Poppins", sans-serif;
    color: #111827;
  }
  .header-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem auto; /* centers the container horizontally if it has a set width */
  width: 100%;       /* make the container take the full width of its parent */
  height: 150px; 
}

#animated-logo {
  width: 350px;  
  height: 350px; 
}

  .page-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .site-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 30px;
    margin-top: 20px;
    text-align: center;
  }
  .site-text {
    font-size: 17px;
    align: center;
    text-align: center;
  }

  .knowledge-centre-columns {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
  }
  
  .knowledge-centre-sidebar {
    flex: 0.8;
    border-radius: 50px;
    padding: 2rem 1rem 2rem 3rem;
    border-radius: 30px;
  }
  
  .category-section {
    margin-bottom: 1.5rem;
  }
  
  .category-section h3 {
    margin-bottom: 0.5rem;
  }
  
  .article-link {
    cursor: pointer;
    margin-bottom: 0.25rem;
    list-style-type: none;
    padding: 0.25rem 0.5rem;
    transition: background-color 0.2s ease;
  }
  
  .article-link:hover {
    color: #d7734b;
    text-shadow: 0px -1px 2px #d7734b91;
  }
  .article-link:active,
  .article-link:focus {
    color: #d7734b;
    text-shadow: 0px -1px 2px #d7734b91;
  }

  .article-link.selected {
  color: #d7734b;
  text-shadow: 0px -1px 2px #d7734b91;
}
  
  .knowledge-centre-article {
    flex: 2;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 7px 8px #c9bf9b54;
    padding: 1.5rem 4rem 2rem 4rem;
    border-radius: 30px;
    min-height: 400px;
  }
  
  .article-meta {
    font-size: 0.9rem;
    color: #555;
    margin-bottom: 1rem;
  }
  
  .article-content {
    margin-top: 1rem;
  }
  
  .error-message {
    color: #dc2626;
    margin-top: 1rem;
  }
  </style>
  